export const formatDate = (val) => {
    if (!val) return '-';
    if (Array.isArray(val) && val.length >= 5) {
        const [y, m, d, hh, mm] = val;
        return `${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y} ${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
    }
    const d = new Date(val);
    return isNaN(d.getTime()) ? String(val) : d.toLocaleString();
};
